import React from 'react';
import { Link } from 'react-router-dom';
import AdminHeader from '../../components/AdminHeader';
import { Plus, Edit, Mail, FileText } from 'lucide-react';

const AdminDashboard = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a0a0f] via-[#1a1a2e] to-[#0a0a0f]">
      <AdminHeader />
      
      <main className="max-w-[1400px] mx-auto px-8 py-12">
        <h1 className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 via-pink-400 to-purple-600 font-['Poppins'] text-5xl font-black mb-8">
          DASHBOARD
        </h1>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Manage Work Items */}
          <Link
            to="/admin/work"
            className="glass-effect rounded-2xl p-8 hover:scale-105 transition-all group border border-purple-500/20 hover:border-purple-500/50"
          >
            <div className="flex items-center justify-between mb-4">
              <Edit className="text-purple-400" size={40} />
              <div className="bg-gradient-to-r from-purple-500 to-pink-500 text-white px-3 py-1 text-sm font-bold rounded-lg">
                MANAGE
              </div>
            </div>
            <h2 className="text-white font-['Poppins'] text-2xl font-bold mb-2">
              WORK ITEMS
            </h2>
            <p className="text-gray-400">
              Create, edit, and delete portfolio work items
            </p>
          </Link>

          {/* Create New Work */}
          <Link
            to="/admin/work/new"
            className="glass-effect rounded-2xl p-8 hover:scale-105 transition-all group border border-pink-500/20 hover:border-pink-500/50"
          >
            <div className="flex items-center justify-between mb-4">
              <Plus className="text-pink-400" size={40} />
              <div className="bg-gradient-to-r from-pink-500 to-purple-500 text-white px-3 py-1 text-sm font-bold rounded-lg">
                CREATE
              </div>
            </div>
            <h2 className="text-white font-['Poppins'] text-2xl font-bold mb-2">
              NEW PROJECT
            </h2>
            <p className="text-gray-400">
              Upload a new project to your portfolio
            </p>
          </Link>

          {/* Edit About */}
          <Link
            to="/admin/about"
            className="glass-effect rounded-2xl p-8 hover:scale-105 transition-all group border border-purple-500/20 hover:border-purple-500/50"
          >
            <div className="flex items-center justify-between mb-4">
              <FileText className="text-purple-400" size={40} />
              <div className="bg-gradient-to-r from-purple-500 to-pink-500 text-white px-3 py-1 text-sm font-bold rounded-lg">
                EDIT
              </div>
            </div>
            <h2 className="text-white font-['Poppins'] text-2xl font-bold mb-2">
              ABOUT PAGE
            </h2>
            <p className="text-gray-400">
              Update your about page content and image
            </p>
          </Link>

          {/* Edit Contact */}
          <Link
            to="/admin/contact"
            className="glass-effect rounded-2xl p-8 hover:scale-105 transition-all group border border-pink-500/20 hover:border-pink-500/50"
          >
            <div className="flex items-center justify-between mb-4">
              <Edit className="text-pink-400" size={40} />
              <div className="bg-gradient-to-r from-pink-500 to-purple-500 text-white px-3 py-1 text-sm font-bold rounded-lg">
                EDIT
              </div>
            </div>
            <h2 className="text-white font-['Poppins'] text-2xl font-bold mb-2">
              CONTACT INFO
            </h2>
            <p className="text-gray-400">
              Update contact information and social links
            </p>
          </Link>

          {/* View Messages */}
          <Link
            to="/admin/messages"
            className="glass-effect rounded-2xl p-8 hover:scale-105 transition-all group border border-purple-500/20 hover:border-purple-500/50"
          >
            <div className="flex items-center justify-between mb-4">
              <Mail className="text-purple-400" size={40} />
              <div className="bg-gradient-to-r from-purple-500 to-pink-500 text-white px-3 py-1 text-sm font-bold rounded-lg">
                VIEW
              </div>
            </div>
            <h2 className="text-white font-['Poppins'] text-2xl font-bold mb-2">
              MESSAGES
            </h2>
            <p className="text-gray-400">
              View and manage contact form submissions
            </p>
          </Link>
        </div>
      </main>
    </div>
  );
};

export default AdminDashboard;